export default "data:image/jpeg;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL21lZGlhL2t2LWFsbC1za3lleGNoYW5nZS1tLmFkNTEzMjYxLmpwZyI7"